const apis = {
    apiMediaUrl: process.env.VUE_APP_BEAR_API_MEDIA,
    apiUrl: process.env.VUE_APP_BEAR_API_ROOT,
    jwt: process.env.VUE_APP_API_TOKEN
};

let gifPitDiv: HTMLDivElement = null;
let pitDiv: HTMLDivElement = null;

/**
 * @see https://github.com/bear2b/argo_webar_library_ts/blob/dev/src/reco.ts#L171
 * @param pageId
 */
export function requestArgoForMarkerData(pageId: number, deviceId: string) {
    return new Promise((resolve, reject) => {
        const Http = new XMLHttpRequest();
        //correct url (bug in current api)
        const url = `${apis.apiUrl}pages?id=${pageId}&_token=${apis.jwt}&device_id=${deviceId}`;
        Http.open("GET", url);
        Http.onload = function() {
            if (Http.status == 200) {
                resolve(Http.response);
            } else {
                reject(Http.status);
            }
        };
        Http.send();
    });
}

export function BuildMediaUrl(url: string): string {
    return `${apis.apiMediaUrl}` + url;
}

export function getGifPit() {
    if (!gifPitDiv) {
        gifPitDiv = document.createElement("div");
        gifPitDiv.setAttribute("id", "three-gif-pit");
        document.body.append(gifPitDiv);
    }

    return gifPitDiv;
}

export function getPit() {
    if (!pitDiv) {
        pitDiv = document.createElement("div");
        pitDiv.setAttribute("id", "videoPit");
        document.body.append(pitDiv);
    }

    return pitDiv;
}
